module.exports = __webpack_public_path__ + "img/Path 520.d0201635.svg";